document.addEventListener('DOMContentLoaded', function () {
  var policyRoot = document.querySelector('.shopify-policy__container, .shopify-policy__body');
  if (!policyRoot) return;

  policyRoot.querySelectorAll('a[href^="mailto:"]').forEach(function (link) {
    if (/ethanyrantran@gmail\.com/i.test(link.getAttribute('href') || '') || /ethanyrantran@gmail\.com/i.test(link.textContent || '')) {
      link.setAttribute('href', 'mailto:info@lifeschoolpacks.com');
      link.textContent = 'info@lifeschoolpacks.com';
    }
  });

  var walker = document.createTreeWalker(policyRoot, NodeFilter.SHOW_TEXT);
  var nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(function (node) {
    var value = node.nodeValue || '';
    value = value.replace(/ethanyrantran@gmail\.com/gi, 'info@lifeschoolpacks.com');
    value = value.replace(/\s*or contact us at LifeSchool Packs,\s*Melbourne,\s*Melbourne VIC 3000,\s*Australia\.?/gi, '');
    value = value.replace(/\s*LifeSchool Packs,\s*Melbourne,\s*Melbourne VIC 3000,\s*Australia\.?/gi, '');
    node.nodeValue = value;
  });
});
